import { Attribution } from 'types'

/** Escape single quotes for SQL string literals */
export const escapeSqlString = (s: string) => s.replace(/'/g, "''")

/**
 * Extra WHERE fragments for campaign / ad set drill-down (Ads Manager–style).
 * - filterCampaignId: restrict rows to one campaign (ad_set and ad groupBy views)
 * - filterAdSetId: restrict to one ad set (ad groupBy only; requires campaign filter in practice)
 *
 * Campaign filter MUST use `{attr}_ad_set.ad_campaign_id`, not `ad_campaign.ad_campaign_id`:
 * k8s_reports_service enrich.js only adds JOINs for tables referenced in SELECT. Count/total
 * queries select COUNT(DISTINCT ad_set.ad_set_id) so `first_ad_set` is joined, but
 * `first_ad_campaign` is not — filtering on first_ad_campaign.* would reference an unjoined table.
 * Ad set rows already carry the campaign id (`ad_set.ad_campaign_id` in available-fields.js).
 */
export function buildAdsTableFilterSql(
  attr: Attribution,
  groupBy: 'campaign' | 'ad' | 'ad_set',
  filterCampaignId?: string | null,
  filterAdSetId?: string | null
): string {
  const attrPrefix = attr === 'first' || attr === 'last' ? `${attr}_` : ''
  const parts: string[] = []
  if (filterCampaignId && (groupBy === 'ad_set' || groupBy === 'ad')) {
    parts.push(
      `AND ${attrPrefix}ad_source.ad_campaign_ext_id = '${escapeSqlString(filterCampaignId)}'`
    )
  }
  if (filterAdSetId && groupBy === 'ad') {
    parts.push(`AND ${attrPrefix}ad_set.ad_set_ext_id = '${escapeSqlString(filterAdSetId)}'`)
  }
  return parts.length ? ` ${parts.join(' ')}` : ''
}
